import { render, staticRenderFns } from "./PopupTaskSubscribers.vue?vue&type=template&id=568b1110&scoped=true&"
import script from "./PopupTaskSubscribers.vue?vue&type=script&lang=js&"
export * from "./PopupTaskSubscribers.vue?vue&type=script&lang=js&"
import style0 from "./PopupTaskSubscribers.vue?vue&type=style&index=0&id=568b1110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568b1110",
  null
  
)

export default component.exports